/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, HFlow, Tag, Text, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { Box } from 'components/Box'
import { useErrorHandler } from 'components/error'
import { Form, FormRenderProps, SubmitButton } from 'components/form'
import { useAlterarBuscaCidadaoPorPropriedadesMutation } from 'graphql/hooks.generated'
import { useConfiguracoes } from 'hooks/configuracoes'

interface ConfiguracoesBuscaCidadaoPropriedadesBoxProps {
  habilitado: boolean
}

export function ConfiguracoesBuscaCidadaoPropriedadesBox(props: ConfiguracoesBuscaCidadaoPropriedadesBoxProps) {
  const { habilitado } = props

  const [alterarBuscaCidadaoPorPropriedades] = useAlterarBuscaCidadaoPorPropriedadesMutation()
  const alert = useAlert()
  const handleRejection = useErrorHandler()
  const { update } = useConfiguracoes()

  const handleSubmit = () => {
    return alterarBuscaCidadaoPorPropriedades({
      variables: {
        input: !habilitado,
      },
    })
      .then((response) => {
        const acaoRealizada = response.data.alterarBuscaCidadaoPorPropriedades.habilitado
          ? 'habilitada'
          : 'desabilitada'
        alert('success', `Busca de cidadão por propriedades ${acaoRealizada} com sucesso`)
        return update()
      })
      .catch(handleRejection)
  }

  const renderForm = (formProps: FormRenderProps) => {
    return (
      <Box style={styles.box}>
        <HFlow>
          <VFlow vSpacing={0.5}>
            <Heading level={3}>Busca de cidadão por propriedades</Heading>
            <Text>
              Melhora o tempo de busca pelo cidadão na Lista de atendimento permitindo que o profissional informe qual a
              propriedade de busca (CPF, nome ou data de nascimento).
            </Text>
            <SubmitButton kind='primary' size='small' handleSubmit={formProps.handleSubmit}>
              {habilitado ? 'Desabilitar' : 'Habilitar'}
            </SubmitButton>
          </VFlow>
          {habilitado ? (
            <Tag type='success' icon='checkCircleFilled'>
              Habilitado
            </Tag>
          ) : (
            <Tag type='normal' icon='banFilled'>
              Desabilitado
            </Tag>
          )}
        </HFlow>
      </Box>
    )
  }

  return <Form onSubmit={handleSubmit} render={renderForm} />
}

const styles = {
  box: css`
    margin-top: 1rem;
  `,
}
